import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker, GoogleMap } from '@angular/google-maps';
import { ActivatedRoute } from '@angular/router';
import { Item } from 'src/app/_core/_interface/item';
import { MapMarkerModel } from 'src/app/_core/_interface/mapMarker';
import { Category } from 'src/app/_core/_interface/markerCategory';
import { DataService } from 'src/app/_services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-google-map-gpt',
  templateUrl: './google-map-gpt.component.html',
  styleUrls: ['./google-map-gpt.component.scss']
})
export class GoogleMapComponentGPT implements OnInit {
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow!: MapInfoWindow;
  @ViewChild('mapContainer', { static: false }) gmap!: ElementRef;

  center: google.maps.LatLngLiteral = { lat: 32.092149, lng: 34.875867 };
  zoom = 12;
  customMarker!: google.maps.Marker;
  markers: any[] = [];
  selectedPlace!: any;
  selectedMarker!: any;
  directionsService = new google.maps.DirectionsService();
  directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
  travelTimeCar: string = '';
  travelTimeWalk: string = '';
  travelTimesFetched: boolean = false;
  places: string = '';
  compId: string;
  styles: any[] = [];
  marker1 = '../assets/img/icon-small.png';
  items: Item[] = [];
  title = 'project';
  lat = 0;
  lng = 0;
  mapWidth: string = '1920';
  mapHeight: string = '1080';

  enabledCustomMarkers: boolean = true;
  customMarkers: MapMarkerModel[] = [
    {
      lat: 31.789173573825362,
      lng: 35.20315950699241,
      title: 'תחנת מרכזית ירושלים',
      description: '',
      category: 'public parks',
    },
    {
      lat: 31.786498955708772,
      lng: 35.20239143366637,
      title: 'בנייני האומה',
      description: '',
      category: 'public parks',
    },
    {
      lat: 31.785747489368397,
      lng: 35.2122327253123,
      title: 'שוק מחנה יהודה',
      description: '',
      category: 'public parks',
    },
    {
      lat: 31.78784566757429,
      lng: 35.19681949463352,
      title: 'מרכז הרב',
      description: '',
      category: 'public parks',
    },
    {
      lat: 31.789187917656562,
      lng: 35.20076733201051,
      title: 'רובע הכניסה לעיר',
      description: '',
      category: 'public parks',
    },
    {
      lat: 31.782854149016053,
      lng: 35.20076733201051,
      title: 'סינמה סיטי',
      description: '',
      category: 'public parks',
    },
    {
      lat: 31.776449131258044,
      lng: 35.169211703029895,
      title: 'יער ירושלים',
      description: '',
      category: 'public parks',
    },


    {
      lat: 31.787765485187407,
      lng: 35.18647263880783,
      title: 'רחוב כנפי נשרים',
      description: '',
      category: 'restaurant',
    },
    {
      lat: 31.775367815958184,
      lng: 35.18777401349241,
      title: 'רחוב אביזוהר',
      description: '',
      category: 'restaurant',
    },
    {
      lat: 31.780436392671565,
      lng: 35.18808206506607,
      title: 'שד הרצל 109',
      description: '',
      category: 'restaurant',
    },
    {
      lat: 31.76821306650147,
      lng: 35.178984378153025,
      title: 'ישראל זנגוויל 1',
      description: '',
      category: 'restaurant',
    }
  ];

  isSelectedGlobal: boolean = false;
  isSelectedCustomMarker: boolean = false;
  customCategories: Category[] = [];
//
// {
//   lat: 31.789173573825362,
//   lng: 35.20315950699241,
//   title: 'תחנת מרכזית ירושלים',
//   description: 'The bustling city center of Haifa',
//   category: 'public parks',
// },
// {
//   lat: 31.786498955708772,
//           lng: 35.20239143366637,
//         title: 'בנייני האומה',
//         description: 'The famous terraced Bahai Gardens',
//         category: 'public parks',
// },
// {
//   lat: 31.78080974014174,
//           lng: 35.20772145414726,
//         title: 'גן סאקר',
//         description: 'One of Israel\'s main seaports',
//         category: 'public parks',
// },
// {
//   lat: 31.785747489368397,
//           lng: 35.2122327253123,
//         title: 'שוק מחנה יהודה',
//         description: 'Israel Institute of Technology',
//         category: 'public parks',
// },
// {
//   lat: 31.78784566757429,
//           lng: 35.19681949463352,
//         title: 'מרכז הרב',
//         description: 'Israel Institute of Technology',
//         category: 'public parks',
// }

  constructor(private route: ActivatedRoute, private dataService: DataService) {
    this.compId = route.snapshot.paramMap.get('id') || '';
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  getCustomMarkerIcon(category: string): string {
    return this.customCategories.find(c => c.internalName === category)?.icon || 'default';
  }

  getMarkerIcon(category: string) {
    const icons = {
      "restaurant": "../assets/img/restaurant.png",
      "school": "../assets/img/school.png",
      "synagogue": "../assets/img/synagogue.png",
      "park": "../assets/img/park.png",
      "supermarket": "../assets/img/supermarket.png",
    }

    return icons[category] || undefined;
  }

  private initializeComponent(): void {
    // Get places parameter from route
    this.places = this.route.snapshot.queryParams.places;

    // Subscribe to search parameters
    this.dataService.searchParameters.subscribe(parameter => {
      this.places = parameter;

      if (this.enabledCustomMarkers && this.customCategories?.some(category => category.internalName === parameter)) { 
        this.loadCustomMarkers();
        this.isSelectedCustomMarker = true;
      } else {
        this.loadNearbyPlaces();
        this.isSelectedCustomMarker = false;
      }
    });

    // Fetch company-specific configurations
    this.dataService.getSpecComp(this.compId).subscribe(comp => {
      if (comp[0].googleMapStyles) {
        this.styles = JSON.parse(comp[0].googleMapStyles);
      }
      if (comp[0].markerImage) {
        this.marker1 = comp[0].markerImage;
      }
      if (comp[0].zoom) {
        this.zoom = comp[0].zoom;
      }
    });

    // Fetch project-specific details
    this.dataService.getSpecProject(this.route.snapshot.paramMap.get('idp')).subscribe(items => {
      this.items = items;

      // Initialize map center and zoom based on project data
      this.lat = +this.items[0].lat;
      this.lng = +this.items[0].lng;
      this.zoom = this.items[0].zoom ? +this.items[0].zoom : 12;
      this.center = { lat: this.lat, lng: this.lng };
      this.enabledCustomMarkers = this.items[0].enableCustomMarkers;
      this.customMarkers = this.items[0].customMarkers;
      this.customCategories = this.items[0].customCategories;

      // Set marker image if available
      if (items[0].markerImage) {
        this.marker1 = items[0].markerImage;
      }

      // Add custom marker and load places
      this.customMarket();
      
      if (this.enabledCustomMarkers && (this.customCategories?.some(category => category.internalName === this.places) || !this.places)) {
        this.loadCustomMarkers();
        this.isSelectedCustomMarker = true;
      } else {
        this.loadNearbyPlaces();
        this.isSelectedCustomMarker = false;
      }
    });
  }
  
  loadGlobalMarkers() {
    if (!this.map.googleMap) return; // Ensure map is initialized
    
    let markers = this.customMarkers.filter(marker => marker.isGlobal) || [];
    
    const globalMarkers = markers.map(marker => ({
      position: { lat: marker.lat, lng: marker.lng },
      map: this.map.googleMap,
      title: marker.title,
      description: marker.description,
      animation: google.maps.Animation.DROP,
      icon: {
        url: '../assets/img/' + marker.icon,
        scaledSize: new google.maps.Size(35, 55),
      },
    }));

    this.markers = [...this.markers, ...globalMarkers];
  }

  loadCustomMarkers() {
    if (!this.map.googleMap) return; // Ensure map is initialized
    
    let markers = this.customMarkers || [];
    if (this.places) {
      markers = this.customMarkers.filter(marker => this.places.includes(marker.category));
    }

    this.markers = markers.map(marker => ({
        position: { lat: marker.lat, lng: marker.lng },
        map: this.map.googleMap,
        title: marker.title,
        description: marker.description,
        animation: google.maps.Animation.DROP,
        icon: {
          url: '../assets/img/' + this.getCustomMarkerIcon(marker.category),
          scaledSize: new google.maps.Size(35, 55),
        },
      }));

      this.loadGlobalMarkers();

  }

  customMarket() {
    if (!this.map.googleMap) return; // Ensure map is initialized
    this.customMarker = new google.maps.Marker({
      position: { lat: this.lat, lng: this.lng },
      map: this.map.googleMap,
      title: 'Custom Marker',
      icon: {
        url: this.marker1
      },
    });
  }

  loadNearbyPlaces() {
    if (!this.map.googleMap || !this.center) return; // Ensure map and center are initialized

    const service = new google.maps.places.PlacesService(this.map.googleMap);
    const request: google.maps.places.PlaceSearchRequest = {
      location: this.center,
      radius: 5000,
      type: this.places || "restaurant",
    };

    service.nearbySearch(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && results) {
        this.markers = results.map(place => ({
          position: place.geometry?.location,
          animation: google.maps.Animation.DROP,
          title: place.name,
          placeId: place.place_id,
          icon: {
            url: this.getMarkerIcon(this.places || "restaurant"),
            scaledSize: new google.maps.Size(35, 55),
          }
        }));

        this.loadGlobalMarkers();
      }
    });
  }

  showRouteToCustomMarker(marker: MapMarker) {
    this.clearPreviousRoute(); // Clear previous route

    const destination = new google.maps.LatLng(marker.getPosition()?.lat(), marker.getPosition()?.lng());
    this.calculateRoute(this.center, destination, google.maps.TravelMode.DRIVING, 'car', marker);
    this.calculateRoute(this.center, destination, google.maps.TravelMode.WALKING, 'walk', marker);

    const markerData = this.customMarkers.find(m => 
      m.lat === marker.getPosition()?.lat() && 
      m.lng === marker.getPosition()?.lng()
    );

    // Check if Street View has an image for this location
    const streetViewService = new google.maps.StreetViewService();
    const location = new google.maps.LatLng(markerData.lat, markerData.lng);
    
    streetViewService.getPanorama({ location, radius: 50 }, (data, status) => {
      if (status === google.maps.StreetViewStatus.OK) { 
        markerData.photoUrl = `https://maps.googleapis.com/maps/api/streetview?size=400x200&location=${markerData.lat},${markerData.lng}&key=${environment.googleMaps.apiKey}`;
      } else {
        markerData.photoUrl = null; // No Street View image available
      }

      this.selectedMarker = {
        name: markerData.title,
        description: markerData.description,
        photoUrl: markerData.photoUrl
      };
    });
  }

  showRouteToPlace(marker: MapMarker, placeId: string) {
    this.clearPreviousRoute(); // Clear previous route

    // Reset selectedPlace and travel times
    this.selectedPlace = null;
    this.travelTimeCar = '';
    this.travelTimeWalk = '';
    this.travelTimesFetched = false;

    const service = new google.maps.places.PlacesService(this.map.googleMap);
    service.getDetails({ placeId: placeId }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && place) {
        const destination = new google.maps.LatLng(place.geometry?.location.lat(), place.geometry?.location.lng());

        // Fetch travel times and show route
        this.calculateRoute(this.center, destination, google.maps.TravelMode.DRIVING, 'car', marker);
        this.calculateRoute(this.center, destination, google.maps.TravelMode.WALKING, 'walk', marker);

        // Populate selectedPlace with new data
        this.selectedPlace = {
          name: place.name,
          address: place.formatted_address,
          phoneNumber: place.formatted_phone_number,
          website: place.website,
          rating: place.rating,
          priceLevel: place.price_level,
          openingHours: place.opening_hours?.weekday_text || [],
          reviews: place.reviews || [],
          photoUrl: place.photos?.[0]?.getUrl({ maxWidth: 400 }) || null,
        };
      }
    });
  }

  calculateRoute(
    origin: google.maps.LatLngLiteral,
    destination: google.maps.LatLng,
    travelMode: google.maps.TravelMode,
    mode: 'car' | 'walk',
    marker: MapMarker
  ) {
    const request = {
      origin: new google.maps.LatLng(origin.lat, origin.lng),
      destination: destination,
      travelMode: travelMode,
    };

    this.directionsService.route(request, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK && result) {
        if (mode === 'car') {
          this.travelTimeCar = result.routes[0].legs[0].duration?.text || '';
        } else if (mode === 'walk') {
          this.travelTimeWalk = result.routes[0].legs[0].duration?.text || '';
        }

        if (mode === 'car') {
          this.directionsRenderer.setMap(this.map.googleMap);
          this.directionsRenderer.setDirections(result);

          this.addCustomMarkers(origin, destination); // Add custom markers manually
        }

        if (mode === 'walk') {
          this.travelTimesFetched = true;
          this.openInfoWindow(marker);
        }
      }
    });
  }

  addCustomMarkers(origin: google.maps.LatLngLiteral, destination: google.maps.LatLng) {
    new google.maps.Marker({
      position: origin,
      map: this.map.googleMap,
      title: 'Start Point',
      icon: {
        url: "",
        scaledSize: new google.maps.Size(0, 0),
      },
    });

    new google.maps.Marker({
      position: destination,
      map: this.map.googleMap,
      title: 'End Point',
      icon: {
        url: "",
        scaledSize: new google.maps.Size(0, 0),
      },
    });
  }

  openInfoWindow(marker: MapMarker) {
    this.infoWindow.close(); // Ensure previous info window is closed
    setTimeout(() => {
      this.infoWindow.open(marker); // Open new info window after a delay
    }, 150);
  }

  openInfo(marker: MapMarker, placeId?: string) {
    this.infoWindow.close();
    this.selectedPlace = null;
    
    this.isSelectedGlobal = this.customMarkers?.find(m => m.lat === marker.getPosition()?.lat() && m.lng === marker.getPosition()?.lng())?.isGlobal;

    if (this.isSelectedCustomMarker || this.isSelectedGlobal) {
      this.showRouteToCustomMarker(marker);
    } else {
      this.showRouteToPlace(marker, placeId);
    }
  }

  clearPreviousRoute() {
    if (this.directionsRenderer) {
      this.directionsRenderer.setMap(null); // Remove the current route from the map
      this.directionsRenderer.setDirections(null); // Clear directions properly
    }
  }

}
